import {NavLink} from "react-router-dom";
import React from "react";
import "./sidebar.css";

const Sidebar = (props) => {
    const {innerWidth: width} = window;

    const onCloseSideBar = () => {
        if (width < 768) {
            props.setCloseSidebar();
        }
    };

    return (
        <React.Fragment>
            <div
                className={props.isSidebar ? "sidebar-container-open" : ""}
                onClick={() => props.setOpenCloseSideBar()}
            ></div>
            <div className={props.isSidebar ? "sidebar" : "sidebar closed"}>
                <div className={"sidebar-header"}></div>
                <div className={"sidebar-body"}>
                    <ul>
                        <li>
                            <NavLink
                                className={({isActive}) =>
                                    isActive ? "link active" : "link"
                                }
                                to={"/address"}
                                onClick={onCloseSideBar}
                            >
                                Address
                            </NavLink>
                        </li>
                        {props.role === "superadmin" && (
                            <li>
                                <NavLink
                                    className={({isActive}) =>
                                        isActive ? "link active" : "link"
                                    }
                                    to={"/users"}
                                    onClick={onCloseSideBar}
                                >
                                    Users
                                </NavLink>
                            </li>
                        )}
                        <li>
                            <NavLink
                                className={({isActive}) =>
                                    isActive ? "link active" : "link"
                                }
                                to={"/profile"}
                                onClick={onCloseSideBar}
                            >
                                Profile
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Sidebar;
